import React from "react";
import  { useState, useEffect } from 'react';
import './classes/ManageAgentMessage.css';
import SalespersonSidebar from './SalespersonSidebar';
import { DataGrid } from '@mui/x-data-grid';
import { configData } from "../config";
import { Link } from '@mui/material';
import Loading from './Loading';
import { Helmet } from 'react-helmet';
import { useNavigate,useParams,useLocation } from 'react-router-dom';

const columns = [
  {
    field: 'agentmessage',
    headerName: 'Agent Message',
    headerClassName: 'super-app-theme--header',
    minWidth: 150, 
    flex:1,  
    sortable: false,
    filterable: false,
    renderCell: (params) => (
      <Link href={params.row.view_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.title}
      </Link>
  ),
    
  },
  {
    field: 'updated',
    headerName: 'Updated date',
    headerClassName: 'super-app-theme--header',
    minWidth: 150, 
    flex:1,  
    sortable: false,
    filterable: false,
  },
  {
    field: 'operations',
    headerName: 'Operations',
    headerClassName: 'super-app-theme--header',
    minWidth: 150, 
    flex:1,  
    sortable: false,
    filterable: false,
    renderCell: (params) => (
        <>
            <Link href={params.row.edit_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
                {params.row.linkText || 'Edit'}
            </Link>
            <span>&nbsp;|&nbsp;</span>
            <Link href={params.row.edit_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
                {params.row.linkText || 'Delete'}
            </Link>
        </>
    ),
  },
];
 
const ManageAgentMessage = () => {

    const [rows, setRows] = React.useState([]);
    const [rowCount, setRowCount] = React.useState(0);
    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
    const [sortModel, setSortModel] = React.useState([]);
    const [filterModel, setFilterModel] = React.useState({ items: [] });
    const app_url = configData.APP_URL;
    const [isLoading, setIsLoading] = useState(true);
 const location  = useLocation();
const successMessage = location.state?.message; // Access the message
     window.history.replaceState({}, '');
    React.useEffect(() => {
     const fetchData = async () => {
        // Simulate API call to your server
        // In a real application, replace this with your actual fetch logic
        try {
           setIsLoading(true);
        const response = await fetch(app_url+'smwwagency/getmanageagentmessagelist', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            page: paginationModel.page,
            pageSize: paginationModel.pageSize,
            sortModel,
            filterModel,
          }),
        });
        const data = await response.json();
        console.log(data.data.rows);
        setRows(data.data.rows);
        setRowCount(data.data.totalRowCount); // Server should return totalRowCount
      }  catch (error) {
              console.error('Error fetching data:', error);
            } finally {
              setIsLoading(false); // Set loading to false after fetch completes (success or error)
            }
      };
  
      fetchData();
     
    }, [paginationModel, sortModel, filterModel]); // Re-fetch data when these change

    return (
         <>
                       {isLoading ? (
                            <Loading />
                          ) : (
        <div id="main">
            <Helmet><title>Manage Agent Message</title></Helmet>
            <div className="left"></div>
            <div className="center left-center">
                {successMessage && (
                        <div className="set-message-done">
                          <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {successMessage}
                        </div>
                        )}
                <div className="agent-message-container">
                    <div className="agent-message-content">
                        <div className="agent-message-link">
                            <a href='/node/add/agent-message' target="_blank" className="form-submit">Add Agent Message</a>
                        </div>
                        <div className="agent-message-table" style={{ width: '100%', overflowX: 'clip',}}>
                            <DataGrid
                                autoHeight={true}
                                rows={rows}
                                columns={columns}
                                rowCount={rowCount}
                                getRowHeight={()=>'auto'} 
                                paginationMode="server"
                                sortingMode="server"
                                // filterMode="server"
                                paginationModel={paginationModel}
                                onPaginationModelChange={setPaginationModel}
                                sortModel={sortModel}
                                onSortModelChange={setSortModel}
                                // filterModel={filterModel}
                                onFilterModelChange={setFilterModel}
                                pageSizeOptions={[5, 10, 25,50]} 
                                pageSize={50}
                                getRowId={() => crypto.randomUUID()}
                                //  hideScrollbar={true}                                         
                                sx={{fontFamily: '"Open Sans", sans-serif, Arial, Verdana','& .MuiDataGrid-row': { marginTop: 1, marginBottom: 1 }, 
                                    '& .coloured': { textAlign: 'center', color: '#7181AD' },
                                    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {display: 'block' },
                                    '& .super-app-theme--header': { fontSize: '14px'},
                                    '.MuiDataGrid-columnHeaderTitle': { fontWeight: 'bold !important',},
                                    '& .MuiDataGrid-cell': {
                                        whiteSpace: 'normal',
                                        wordWrap: 'break-word',
                                        lineHeight: '1.4',
                                        alignItems: 'center', 
                                        display: 'flex',
                                    },
                                    '& .emailcode-wrap': {
                                        whiteSpace: 'normal',
                                        wordWrap: 'break-word',
                                        lineHeight: '1.4',
                                        alignItems: 'center',  
                                    },
                                    '& .MuiTablePagination-actions': {
                                        marginRight: 10,
                                    },
                                }}  
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="right">
                <SalespersonSidebar />
            </div>
        </div>
         )}
    </>  
   
    );
};
export default ManageAgentMessage;